import { InputProps as ChakraInputProps } from "@chakra-ui/react";
import {
  FieldError,
  UseFormRegister,
  Merge,
  FieldErrorsImpl,
} from "react-hook-form";
import { useState } from "react";
import { FormLabelLegend } from "../../atoms/FormLabel/FormLabelLegend";
import { FlexCenter } from "../../atoms/Flex/FlexCenter";
import { FormControlFieldset } from "../../atoms/FormControl/FormControlFieldset";
import { FormErrorMessageDefault } from "../../atoms/FormErrorMessage/FormErrorMessageDefault";

interface InputProps extends ChakraInputProps {
  name: string;
  id: string;
  isRequired?: boolean;
  default_country?: string;
}
interface FormControlMaterialUIProps {
  isRequired?: boolean;
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
  name: string;
  text: string;
  bg?: string;
  register: UseFormRegister<any>;
  input: React.ForwardRefExoticComponent<
    InputProps & React.RefAttributes<HTMLInputElement>
  >;
  is_totem?: boolean;
  default_country?: string;
}

export function FormControlMaterialUI({
  text,
  name,
  error,
  register,
  bg = "rgba(0, 0, 0, 0.12)",
  input: Input,
  isRequired,
  is_totem,
  default_country,
}: FormControlMaterialUIProps) {
  const [focus, setFocus] = useState(false);
  return (
    <>
      <FormControlFieldset
        isRequired={isRequired}
        focus={focus}
        bg={bg}
        error={!!error}
        id={name}
      >
        <FormLabelLegend
          text={text}
          htmlFor={name}
          color={focus ? bg : undefined}
        />
        <FlexCenter>
          <Input
            default_country={default_country}
            variant="unstyled"
            {...register(name)}
            id={name}
            isRequired={isRequired}
            onFocus={() => setFocus(true)}
            onBlur={() => {
              setFocus(false);
            }}
            autoComplete={is_totem ? "off" : "on"}
          />
        </FlexCenter>
      </FormControlFieldset>
      {!!error && <FormErrorMessageDefault error={error.message as string} />}
    </>
  );
}
